// PasswordField.jsx
import React, { useState } from "react";
import { Field } from "react-final-form";
import { isPasswordImprovedValid } from "../../util/revalidateUtils";
import { FiEye, FiEyeOff } from "react-icons/fi"; // Iconos de ojo
// import normalizePassword si lo usas

// Componente para mostrar la fuerza de la contraseña
const PasswordStrengthMeter = ({ password }) => {
  if (!password) return null;

  let score = 0;
  if (password.length >= 12) score++;
  if (/[A-Za-z]/.test(password) && /\d/.test(password)) score++;
  if (/[^A-Za-z\d\s]/u.test(password)) score++; // símbolo o emoji
  if (password.length >= 16) score++;

  const strengthLabels = [
    "Muy débil",
    "Débil",
    "Media",
    "Fuerte",
    "Muy fuerte",
  ];
  const colors = ["#ff4d4f", "#ff7a45", "#ffc53d", "#40a9ff", "#73d13d"]; // rojo → verde

  return (
    <div style={{ marginTop: 8 }}>
      {/* Label de fuerza */}
      <div
        style={{
          fontWeight: 600,
          fontSize: 14,
          color: colors[score],
          marginBottom: 4,
        }}
      >
        {strengthLabels[score]}
      </div>

      {/* Barra de fuerza */}
      <div
        style={{
          height: 8,
          width: "100%",
          background: "#e6e6e6",
          borderRadius: 6,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${((score + 1) / 5) * 100}%`,
            background: `linear-gradient(90deg, ${colors[score]} 0%, ${colors[score]} 100%)`,
            borderRadius: 6,
            transition: "width 0.3s ease-in-out",
          }}
        />
      </div>
    </div>
  );
};

const PasswordField = ({
  name,
  placeholder,
  maxLength,
  showPasswordStrengthMeter = true,
  extraValidation = true,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Field name={name} validate={extraValidation && isPasswordImprovedValid}>
      {({ input, meta }) => (
        <div style={{ marginBottom: 16, position: "relative" }}>
          <input
            {...input}
            placeholder={placeholder}
            type={showPassword ? "text" : "password"}
            maxLength={maxLength}
            style={{
              width: "100%",
              padding: "10px 40px 10px 10px", // espacio para el icono
              fontSize: 16,
              borderRadius: 6,
              border:
                meta.touched && meta.error ? "1px solid red" : "1px solid #ccc",
            }}
          />

          {/* Icono fijo */}
          <span
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: 10,
              top: "24px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#666",
            }}
          >
            {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
          </span>

          {showPasswordStrengthMeter && (
            <PasswordStrengthMeter password={input.value} />
          )}

          {meta.touched && meta.error ? (
            <div className="ui red pointing basic label">{meta.error}</div>
          ) : null}
        </div>
      )}
    </Field>
  );
};

export default PasswordField;
